import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import type { IBookPreview } from '@shared/jp/data/products';
import type { TBookAlias, TProductAlias } from '@shared/jp/product';
import { getBookByAlias } from 'src/app/data/books/utils';
import { EButtonColor } from '@studiobuki/web-core/lib/button';
import { RoutingService } from 'src/app/services/routing.service';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-book-select-dialog',
  templateUrl: './book-select-dialog.component.html',
  styleUrls: ['./book-select-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookSelectDialogComponent {
  public readonly books: IBookPreview[] = [];

  public readonly EButtonColor = EButtonColor;

  constructor(
    private _routing: RoutingService,
    public mediaService: MediaService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      aliasArr: TProductAlias[];
    },
    public dialogRef: MatDialogRef<BookSelectDialogComponent, TProductAlias>,
  ) {
    data.aliasArr.forEach((alias) => {
      const book = getBookByAlias(alias as TBookAlias);

      this.books.push(book);
    });
  }

  async onSelect(alias: TProductAlias) {
    this.dialogRef.close(alias);
  }
}
